import { useHotkeys } from 'react-hotkeys-hook'

import { useCommandMenu } from '~/components/command-menu/hooks/useCommandMenu'

export const useBackspaceGoBack = ({ enabled }: { enabled: boolean }): void => {
  const { goBack } = useCommandMenu()

  useHotkeys('backspace', () => goBack(), { enableOnFormTags: true, enabled }, [
    enabled,
    goBack,
  ])
}
